import './setPublicPath';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initClientErrorReporter, reportClientError } from './lib/clientErrorReporter';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';

// Глобальный перехват JS-ошибок фронта/EXE → бэкенд-ловец (карточки source=frontend/exe).
initClientErrorReporter();

// Отчёты, пойманные ВНЕ рендерера (main-процесс Electron, питон-воркеры sud_login/
// otmena_worker/pdf_worker — main.js сканирует их stderr на [ERROR_REPORT] и релеит
// сюда через IPC) — заводим в тот же ловец с source='exe'. Исходный под-источник
// (main_process/sud_login/...) кладём в текст сообщения — их схема этого не различает.
window.desktopApp?.onDesktopErrorReport?.((report) => {
  reportClientError(
    { message: `[${report.source}] ${report.message}`, stack: report.stack || '' },
    { source: 'exe' }
  );
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ErrorBoundary>
);
